import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { getUsersListQueryKey } from 'features/users/queries';
import { changeRoleInCommunity } from '../../services';
import { getCommunityMembersKey, getCommunityQueryKey } from '../keys';

export const useDeleteUserFromCommunity = () => {
  const queryClient = useQueryClient();

  return useMutation<undefined, { communityId: string; userId: string }>({
    async mutationFn({ communityId, userId }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const result = await changeRoleInCommunity({
        data: [
          {
            entity_ids: [communityId],
            entity_type: 'Community',
            roles: [],
            user_id: userId,
          },
        ],
      });
      return result.data;
    },
    /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

    async onSuccess(_, params: { communityId: string }) {
      await queryClient.invalidateQueries({ queryKey: getCommunityQueryKey({ id: params.communityId }) });
      await queryClient.invalidateQueries({ queryKey: getCommunityMembersKey({ communityId: params.communityId }) });
      await queryClient.invalidateQueries({ queryKey: getUsersListQueryKey({}) });
    },
  });
};
